import { NgModule } from '@angular/core';
import { PhBhpInputSanitizerDirective } from './directives/ph-bhp-input-sanitizer/ph-bhp-input-sanitizer.directive';
import { PhBhpLabelSanitizerPipe } from './pipes/ph-bhp-label-sanitizer/ph-bhp-input-sanitizer.pipe';
 
@NgModule({
  declarations: [ PhBhpInputSanitizerDirective, PhBhpLabelSanitizerPipe],
  exports: [ PhBhpInputSanitizerDirective, PhBhpLabelSanitizerPipe]
})
export class PhBhpUiModule { }
